import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

interface BlockedTimeSlot {
  id: number;
  startTime: string;
  endTime: string;
  createdBy: number;
  createdAt: string;
}

export function useBlockedTimeSlots(date: Date | null | undefined) {
  return useQuery<BlockedTimeSlot[]>({
    queryKey: ["blocked-time-slots", date],
    queryFn: async () => {
      if (!date) return [];
      
      const dateStr = format(date, "yyyy-MM-dd");
      const res = await fetch(`/api/admin/blocked-time-slots?date=${dateStr}`);
      
      if (!res.ok) {
        throw new Error("Failed to fetch blocked time slots");
      }
      
      return res.json();
    },
    enabled: !!date,
  });
}